"use strict";

const Tooltip = () => {
    const init = () => {
        window.refreshTooltips = function(){
            var $tooltips = $('.js-tooltip');
            if ($tooltips.length > 0) {
                var $tooltipTriggers = $tooltips.find('.js-tooltip-trigger');
                
                $tooltipTriggers.off('click');
                $tooltipTriggers.on('click', function(){
                    var $parent = $(this).parents('.js-tooltip');
                    if($parent.hasClass('active')){
                        $tooltips.removeClass('active');
                    }else{
                        $tooltips.removeClass('active');
                        $parent.addClass('active')
                    }
                });
                
                $(document).off('click.tooltip');
                $(document).on('click.tooltip', function(event) {
                    if ($(event.target).closest('.js-tooltip').length === 0) {
                        $tooltips.removeClass('active');
                    }
                });
            }
        }

        $(function() {
            refreshTooltips();
        });
    };

    return {
        init:init
    };
};

export default Tooltip;